import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Popup, Table} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import PartCode from './partCode';
import PartQuantity from './partQuantity';
import DeleteIcon from './deleteIcon';

class OrderElement extends Component {
  handleBackOrderClick(partCode) {
    this.props.showOrderPartBackOrder(partCode);
  }

  handleOnOrderClick(partCode) {
    this.props.showOrderPartOnOrder(partCode);
  }

  handleSOQClick(partCode) {
    this.props.showOrderPartSOQResume(partCode);
  }

  renderRejection(code, description) {
    return (
      <Popup inverted content={description} trigger={<span>{code || 'V'}</span>} />
    );
  }

  renderBackOrderLink(partCode, backOrder) {
    if (parseInt(backOrder, 10) === 0) {
      return 0;
    }

    return (
      <a onClick={() => this.handleBackOrderClick(partCode)}>
        {backOrder}
      </a>
    );
  }

  renderOnOrderLink(partCode, onOrder) {
    if (parseInt(onOrder, 10) === 0) {
      return 0;
    }

    return (
      <a onClick={() => this.handleOnOrderClick(partCode)}>
        {onOrder}
      </a>
    );
  }

  renderSOQLink(partCode, SOQ) {
    return (
      <a onClick={() => this.handleSOQClick(partCode)}>
        {SOQ}
      </a>
    );
  }

  render() {
    const {index, element} = this.props;

    return (
      <Popup flowing inverted
        content={`Línea ${index + 1} | ${element.name}`}
        trigger={
          <Table.Row>
            <Table.Cell textAlign='center'>
              {this.renderRejection(element.rejectionCode, element.rejectionDescription)}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <PartCode index={index} partCode={element.partCode} partName={element.name} />
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {element.ICC}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              {element.scc}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {element.salesMad}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {this.renderBackOrderLink(element.partCode, element.bo)}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {element.oh}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {this.renderOnOrderLink(element.partCode, element.oo)}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {element.partProcessedQuantity}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {element.receivedQuantity}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {this.renderSOQLink(element.partCode, element.partQuantitySuggested)}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              {this.renderSOQLink(element.partCode, element.soqOrders)}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <PartQuantity index={index} partQuantity={element.partQuantity} />
            </Table.Cell>
            <Table.Cell textAlign='right'>
              $ {getNumericValue(element.unitFob, 2)}
            </Table.Cell>
            <Table.Cell textAlign='right'>
              $ {getNumericValue(element.totalFob, 2)}
            </Table.Cell>
            <Table.Cell textAlign='center'>
              <DeleteIcon index={index} />
            </Table.Cell>
          </Table.Row>
        }
      />
    );
  }
}

const {
  showOrderPartBackOrder,
  showOrderPartOnOrder,
  showOrderPartSOQResume,
} = Actions;

export default connect(null, {
  showOrderPartBackOrder,
  showOrderPartOnOrder,
  showOrderPartSOQResume,
})(OrderElement);
